// extracted by mini-css-extract-plugin
export default {"expired_notice":"ExpiredNotice_expired_notice__crO4y","expired_title":"ExpiredNotice_expired_title__6L5sv","expired_message":"ExpiredNotice_expired_message__ZC0qt"};